<template>
    <input-number
        v-if="cellEditing || cellEditable"
        v-bind="$attrs"
        v-on="editEvents"
        :value="value"
        :readonly="!cellEditing || $attrs.readonly"
        :inputStyle="inputStyle"
        @input="onChange"
        @on-blur="onBlur"
    >
    </input-number>
    <cell-render
        v-else-if="render"
        :render="render"
        :context="$props"
    ></cell-render>
    <div v-else :class="prefixCls + '-wrap-readonly'" data-cls="cell-content">
        <slot>
            <span>{{ curVal }}</span>
        </slot>
    </div>
</template>
<script>
import mixin from './mixin'
import InputNumber from '../input-mask-number'
import { currency } from '../../utils/assist'

export default {
    name: 'CellInputNumber',
    mixins: [mixin],
    components: {
        InputNumber,
    },
    computed: {
        // 小数位
        decimalLimit() {
            var { allowDecimal, decimalLimit } = this.$attrs

            if (typeof allowDecimal == 'undefined') {
                allowDecimal = true
            }

            if (typeof decimalLimit == 'undefined') {
                decimalLimit = 2
            }

            return allowDecimal ? decimalLimit : 0
        },
        curVal() {
            return currency(this.value, this.decimalLimit)
        },
        inputStyle() {
            return {
                textAlign: this.align,
            }
        },
    },
    methods: {
        onBlur(e) {
            if (this.value == '') {
                this.editNode.editCellChange(this.key, 0)
            }

            if (this.editEvents['on-blur']) {
                this.editEvents['on-blur'](e)
            }
        },
    },
}
</script>
